import Unit from '@/models/list/Unit';

import APIService from '@/services/APIService';

const NAMESPACE = 'course-units';

export default {

  index(params, rOptions = {}) {
    return APIService.get(NAMESPACE, {
      params,
      rOptions: {
        model: Unit,
        many: true,
        ...rOptions,
      },
    });
  },

  show(id, params) {
    return APIService.get(`${NAMESPACE}/${id}`, {
      params,
      rOptions: {
        model: Unit,
      },
    });
  },

  create(data, obs) {
    return APIService.post(NAMESPACE, data, { rOptions: { obs } });
  },

  delete(id) {
    return APIService.delete(`${NAMESPACE}/${id}`);
  },

  getCourseUnitUser(id, userid, params) {
    return APIService.get(`${NAMESPACE}/${id}/users/${userid}`, { params });
  },

  getUnitlessons(id) {
    return APIService.get(`/lessons?search[course_unit_id]=${id}`);
  },
  /**
   * Обновление данных темы (course_unit'а)
   * @param id
   * @param data
   * @returns {Promise<AxiosResponse<T>>}
   */
  updateCourseUnit(id, data) {
    return APIService.put(`${NAMESPACE}/${id}`, data);
  },

  passUnit(id, data) {
    return APIService.post(`/course-unit/${id}/passed`, data);
  },
};
